export const SET_CANDIDATES = 'SET_CANDIDATES';
export const SET_CANDIDATES_ROLE = 'SET_CANDIDATES_ROLE';
export const SET_CANDIDATES_LOADING = 'SET_CANDIDATES_LOADING';

